import { IServiceResponse } from "../interfaces/service.response";
import { IServiceRequest } from "../interfaces/service.request";
import { BoxQuotaData } from "./box.quote.data";
import { DataService } from '../services/data/data.service';
import {
    HistoryItemPeriod,
    getRangeFromHistoryItemPeriod,
    getHistoryItemPeriodValue,
    IHistoryItem,
    PERIOD_TIMESTAMP_MULTIPLIER
} from "../interfaces/historyItem";
import { monitorPeriodsService, selectedPeriods } from "../services/monitorPeriods/monitorPeriods.service";
import { Workspace } from "./workspace.data";
import { QuoteTabWizardComponent } from "../components/quoteTabWizard/quoteTabWizard.component";
import { WakeUpService } from '../services/wakeUp.service';
import { ChartDisplayMode } from "../enums/ChartDisplayMode.list";

export interface IMIndicatorResult {
    Count: number;
    Color: "red" | "yellow" | "green";
}


export class MonitorSelectedSymbol {
    long: number = 0;
    short: number = 0;
    middle: number = 0;
    entry: number = 0;

    ma: number = 0;
    maColor: "red" | "yellow" | "green" = "yellow";

    m1: number = 0;
    m2: number = 0;
    m3: number = 0;

    private _maPeriod: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get maPeriod(): HistoryItemPeriod {
        return this._maPeriod;
    }
    public set maPeriod(v: HistoryItemPeriod) {
        this._maPeriod = v;
    }

    private _m1Period: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get m1Period(): HistoryItemPeriod {
        return this._m1Period;
    }
    public set m1Period(v: HistoryItemPeriod) {
        this._m1Period = v;
    }

    private _m2Period: HistoryItemPeriod = HistoryItemPeriod.Min90;
    public get m2Period(): HistoryItemPeriod {
        return this._m2Period;
    }
    public set m2Period(v: HistoryItemPeriod) {
        this._m2Period = v;
    }

    private _m3Period: HistoryItemPeriod = HistoryItemPeriod.Hr3;
    public get m3Period(): HistoryItemPeriod {
        return this._m3Period;
    }
    public set m3Period(v: HistoryItemPeriod) {
        this._m3Period = v;
    }

    private _longPeriod: HistoryItemPeriod = HistoryItemPeriod.Hr24;
    public get longPeriod(): HistoryItemPeriod {

        if(this.workspace.mobileMode!="desktop")
        {
            return this.workspace.getCorrectPeriod(this.workspace.charts.ach1.Period[ChartDisplayMode.ENTSIGNALS])
        }
      
        return this.workspace.getCorrectPeriod(this.workspace.charts.ach1.Period[ChartDisplayMode.ENTSIGNALS]);
       

    }
    public set longPeriod(v: HistoryItemPeriod) {
        this._longPeriod = v;
    }

    private _shortPeriod: HistoryItemPeriod = HistoryItemPeriod.Hr3;
    public get shortPeriod(): HistoryItemPeriod {
        //    return this._shortPeriod;
        if(this.workspace.mobileMode!="desktop")
        {
            return this.workspace.getCorrectPeriod(this.workspace.charts.ach3.Period[ChartDisplayMode.ENTSIGNALS])
        }
        //return this.workspace.charts.ach3.Period[this.workspace.charts.ach3.DisplayMode];
        return this.workspace.getCorrectPeriod(this.workspace.charts.ach3.Period[ChartDisplayMode.ENTSIGNALS]);
       
    }
    public set shortPeriod(v: HistoryItemPeriod) {
        this._shortPeriod = v;
    }

    private _midPeriod: HistoryItemPeriod = HistoryItemPeriod.Hr6;
    public get midPeriod(): HistoryItemPeriod {
        //  return this._midPeriod;
        if(this.workspace.mobileMode!="desktop")
        {
           return this.workspace.getCorrectPeriod(this.workspace.charts.ach2.Period[ChartDisplayMode.ENTSIGNALS])
        }
         //return this.workspace.charts.ach2.Period[this.workspace.charts.ach2.DisplayMode];
         return this.workspace.getCorrectPeriod(this.workspace.charts.ach2.Period[ChartDisplayMode.ENTSIGNALS]);
       
    }
    public set midPeriod(v: HistoryItemPeriod) {
        this._midPeriod = v;
    }

    private _entryPeriod: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get entryPeriod(): HistoryItemPeriod {
        // return this._entryPeriod;
        if(this.workspace.mobileMode!="desktop")
        {
            //return this.workspace.charts.ach1.Period[this.workspace.charts.ach1.DisplayMode];
            return this.workspace.getCorrectPeriod(this.workspace.charts.ach4.Period[ChartDisplayMode.ENTSIGNALS]);
        }
         //return this.workspace.charts.ach4.Period[this.workspace.charts.ach4.DisplayMode]
         return this.workspace.getCorrectPeriod(this.workspace.charts.ach4.Period[ChartDisplayMode.ENTSIGNALS])
        
    }
    public set entryPeriod(v: HistoryItemPeriod) {
        this._entryPeriod = v;
    }

    private _VLPeriod: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get VLPeriod (): HistoryItemPeriod {
        return this._VLPeriod;
    }
    public set VLPeriod ( value: HistoryItemPeriod ) {
        this._VLPeriod = value;
    }


    private _BSPeriod: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get BSPeriod (): HistoryItemPeriod {
        return this._BSPeriod;
    }
    public set BSPeriod ( value: HistoryItemPeriod ) {
        this._BSPeriod = value;
    }


    private _rangeEnd: number = NaN;
    public get rangeEnd(): number {
        return this._rangeEnd;
    }
    public set rangeEnd(v: number) {
        this._rangeEnd = v;
    }

    private _buyAndSell: number = 0;
    public set buyAndSell(v: number) {
        this._buyAndSell = v;
    }

    public get buyAndSell() {
        return this._buyAndSell;
    }

    public get box(): BoxQuotaData {
        return this.workspace.boxes.filter(x => x.Symbol == this.Symbol)[0];
    }

    _requestMAId: string = "";
    _requestM1Id: string = "";
    _requestM2Id: string = "";
    _requestM3Id: string = "";

    _requestLId: string = "";
    _requestMId: string = "";
    _requestSId: string = "";
    _requestEId: string = "";
    _requestVLId: string = "";
    _requestBSId: string = "";

    _pip: number = 0.0001;

    _dataMA: anychart.data.Table | undefined;
    _dataM1: anychart.data.Table | undefined;

    _dataM2: anychart.data.Table | undefined;
    _dataM3: anychart.data.Table | undefined;

    _dataL: anychart.data.Table | undefined;
    _dataM: anychart.data.Table | undefined;
    _dataS: anychart.data.Table | undefined;
    _dataE: anychart.data.Table | undefined;

    _dataVL: anychart.data.Table | undefined;
    _dataBS: anychart.data.Table | undefined;

    _prevHistoryPiontMA: number[] = [];
    _prevHistoryPiontM1: number[] = [];
    _prevHistoryPiontM1_temp: number[] = [];
    _prevHistoryPiontBS: number[] = [];
    _prevHistoryPiontBS_temp: number[] = [];
    _prevHistoryPiontM2: number[] = [];
    _prevHistoryPiontM3: number[] = [];

    _lastPiontMA: number[] = [];
    _lastPiontM1: number[] = [];
    _lastPiontM2: number[] = [];
    _lastPiontM3: number[] = [];
    _lastPiontL: number[] = [];
    _lastPiontM: number[] = [];
    _lastPiontS: number[] = [];
    _lastPiontE: number[] = [];
    _lastPiontVL: number[] = [];
    _lastPiontBS: number[] = [];

    _timeoutE: any;
    _timeoutM: any;
    _timeoutS: any;
    _timeoutL: any;

    _timeoutMA: any;
    _timeoutM1: any;
    _timeoutM2: any;
    _timeoutM3: any;
    _timeoutBS: any;

    _requestId: string = `M_${Date.now()}_${Math.random()}`;

    constructor(
        private dataService: DataService,
        private workspace: Workspace,
        public Symbol: string,
        public limit: number = 100,
        public monitorPeriodsService: monitorPeriodsService,
        protected wakeUp:WakeUpService
    ) {
        this._dataMA = this._dataMA || anychart.data.table();
        this._dataM1 = this._dataM1 || anychart.data.table();
        this._dataM2 = this._dataM2 || anychart.data.table();
        this._dataM3 = this._dataM3 || anychart.data.table();
        this._dataE = this._dataE || anychart.data.table();
        this._dataM = this._dataM || anychart.data.table();
        this._dataL = this._dataL || anychart.data.table();
        this._dataS = this._dataS || anychart.data.table();
        this._dataVL = this._dataVL || anychart.data.table();
        this._dataBS = this._dataBS || anychart.data.table();

        this.monitorPeriodsService.selectedPeriods.subscribe(t => {
            this.m1Period = t.s1;
            this.m2Period = t.s2;
            this.m3Period = t.s3;
         //   this.BSPeriod = t.BS;
        //    this.VLPeriod = t.VL;
            this.requestForData();
        });

        this.dataService.dataSubscriber.subscribe(response => {
           this.updateData(response);
           this.updateFromTicks(response);
        });

        setTimeout(() => {
            this.requestForData();
        }, 1000);

        this.wakeUp.wakeUpSubscriber.subscribe(()=>{
            setTimeout(()=>{
                // reaload current symbol/period after wakeup
                this.requestForData();
            },1000);// after 1 sec
        });
    }

    public returnFix() {
       
    }

    public quoteTabObj?: QuoteTabWizardComponent;
    private _defaultNumberofPoints: number = 200;
    public get defaultNumberofPoints(): number {
        return this._defaultNumberofPoints;
    }
    public set defaultNumberofPoints(value: number) {
        this._defaultNumberofPoints = value;
    }
    public requestForData(v: any = null): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this._dataM1 = this._dataM1 || anychart.data.table();
            this._dataM2 = this._dataM2 || anychart.data.table();
            this._dataM3 = this._dataM3 || anychart.data.table();
            this._dataMA = this._dataMA || anychart.data.table();

            this._dataM = this._dataM || anychart.data.table();
            this._dataL = this._dataL || anychart.data.table();
            this._dataS = this._dataS || anychart.data.table();
            this._dataE = this._dataE || anychart.data.table();
            if (v != null) {
                this.quoteTabObj = v;                
                this.requestPeriod(this._dataM1, this.m1Period, this.defaultNumberofPoints).then(r => {
                   
                    if(typeof(r)=="string"){
                        this._requestM1Id = r;
                    } else {
                        this._requestM1Id = r.ReqID ||'';
                        this.updateData(r);
                    }
                    this.requestPeriod(this._dataM2!, this.m2Period, this.defaultNumberofPoints).then(r => {
                        
                        if(typeof(r)=="string"){
                            this._requestM2Id = r;
                        } else {
                            this._requestM2Id = r.ReqID ||'';
                            this.updateData(r);
                        }
                        this.requestPeriod(this._dataM3!, this.m3Period, this.defaultNumberofPoints).then(r => {
                            
                            if(typeof(r)=="string"){
                                this._requestM3Id = r;
                            } else {
                                this._requestM3Id = r.ReqID ||'';
                                this.updateData(r);
                            }
                            rs();
                        }).catch(e => { console.error(e); });
                    }).catch(e => { console.error(e); });
                }).catch(e => { console.error(e); });
            } else {
                this.requestPeriod(this._dataM1, this.m1Period, this.defaultNumberofPoints).then(r => {                    
                    if(typeof(r)=="string"){
                        this._requestM1Id = r;
                    } else {
                        this._requestM1Id = r.ReqID ||'';
                        this.updateData(r);
                    }
                    this.requestPeriod(this._dataM2!, this.m2Period, this.defaultNumberofPoints).then(r => {                        
                        if(typeof(r)=="string"){
                            this._requestM2Id = r;
                        } else {
                            this._requestM2Id = r.ReqID ||'';
                            this.updateData(r);
                        }
                        this.requestPeriod(this._dataM3!, this.m3Period, this.defaultNumberofPoints).then(r => {
                            
                            if(typeof(r)=="string"){
                                this._requestM3Id = r;
                            } else {
                                this._requestM3Id = r.ReqID ||'';
                                this.updateData(r);
                            }
                            this.requestPeriod(this._dataMA!, this.maPeriod, this.defaultNumberofPoints).then(r => {
                                
                                
                            if(typeof(r)=="string"){
                                this._requestMAId = r;
                            } else {
                                this._requestMAId = r.ReqID ||'';
                                this.updateData(r);
                            }
                                this.requestPeriod(this._dataL!, this.longPeriod, this.defaultNumberofPoints).then(
                                    r => {
                                        
                                        if(typeof(r)=="string"){
                                            this._requestLId = r;
                                        } else {
                                            this._requestLId = r.ReqID ||'';
                                            this.updateData(r);
                                        }
                                        this.requestPeriod(
                                            this._dataM!,
                                            this.midPeriod,
                                            this.defaultNumberofPoints
                                        ).then(r => {
                                            
                                            
                                        if(typeof(r)=="string"){
                                            this._requestMId = r;
                                        } else {
                                            this._requestMId = r.ReqID ||'';
                                            this.updateData(r);
                                        }
                                            this.requestPeriod(
                                                this._dataS!,
                                                this.shortPeriod,
                                                this.defaultNumberofPoints
                                            ).then(r => {
           
                                        if(typeof(r)=="string"){
                                            this._requestSId = r;
                                        } else {
                                            this._requestSId = r.ReqID ||'';
                                            this.updateData(r);
                                        }
                                                this.requestPeriod(
                                                    this._dataE!,
                                                    this.entryPeriod,
                                                    this.defaultNumberofPoints
                                                ).then(r => {
                                                    
                                                    if(typeof(r)=="string"){
                                                        this._requestVLId = r;
                                                    } else {
                                                        this._requestVLId = r.ReqID ||'';
                                                        this.updateData(r);
                                                    }
                                                    this.requestPeriod(
                                                        this._dataVL!,
                                                        this.VLPeriod,
                                                        this.defaultNumberofPoints
                                                    ).then(r => {
                                                        
                                                        
                                                    if(typeof(r)=="string"){
                                                        this._requestBSId = r;
                                                    } else {
                                                        this._requestBSId = r.ReqID ||'';
                                                        this.updateData(r);
                                                    }
                                                        this.requestPeriod(
                                                            this._dataBS!,
                                                            this.BSPeriod,
                                                            this.defaultNumberofPoints,true
                                                        ).then(r => {
                                                    
                                                    if(typeof(r)=="string"){
                                                        this._requestEId = r;
                                                    } else {
                                                        this._requestEId = r.ReqID ||'';
                                                        this.updateData(r);
                                                    }
                                                    rs();
                                                }).catch(e => { console.error(e); });
                                            }).catch(e => { console.error(e); });
                                        }).catch(e => { console.error(e); });
                                    }
                                );
                            }).catch(e => { console.error(e); });
                        }).catch(e => { console.error(e); });
                    }).catch(e => { console.error(e); });}).catch(e => { console.error(e); });}).catch(e => { console.error(e); });
                }).catch(e => { console.error(e); });
            }
        });
    }

    public setNewLongperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.longPeriod = v;
            this._dataL = this._dataL || anychart.data.table();
            this.requestPeriod(this._dataL, this.longPeriod, this.defaultNumberofPoints).then(r => {
                if(typeof(r)=="string"){
                    this._requestLId = r;
                } else {
                    this._requestLId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }

    public setNewMidperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.midPeriod = v;
            this._dataM = this._dataM || anychart.data.table();
            this.requestPeriod(this._dataM, this.midPeriod, this.defaultNumberofPoints).then(r => {                
                if(typeof(r)=="string"){
                    this._requestMId = r;
                } else {
                    this._requestMId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }

    public setNewShortperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.shortPeriod = v;
            this._dataS = this._dataS || anychart.data.table();
            this.requestPeriod(this._dataS, this.shortPeriod, this.defaultNumberofPoints).then(r => {                
                if(typeof(r)=="string"){
                    this._requestSId = r;
                } else {
                    this._requestSId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }


    public setNewEntryperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.entryPeriod = v;
            this._dataE = this._dataE || anychart.data.table();
            this.requestPeriod(this._dataE, this.entryPeriod, this.defaultNumberofPoints).then(r => {                
                if(typeof(r)=="string"){
                    this._requestEId = r;
                } else {
                    this._requestEId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }

    public refreshPeriodsAfterSwitch()
    {
        
        // this.setNewLongperiod( this.workspace.getCorrectPeriod(this.longPeriod));
        // this.setNewMidperiod( this.workspace.getCorrectPeriod(this.midPeriod));
        // this.setNewShortperiod( this.workspace.getCorrectPeriod(this.shortPeriod));
        // this.setNewEntryperiod( this.workspace.getCorrectPeriod(this.entryPeriod));
       // this.workspace.globaGridMode.longSymbolPeriod.next(this.workspace.getCorrectPeriod(this.longPeriod));
    }










    public setNewVLperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.VLPeriod = v;
            
            this._dataVL = this._dataVL || anychart.data.table();
            this.requestPeriod(this._dataVL, this.VLPeriod, this.defaultNumberofPoints).then(r => {                
                if(typeof(r)=="string"){
                    this._requestVLId = r;
                } else {
                    this._requestVLId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }

    public chartRange:any;

    public setNewBSperiod(v: HistoryItemPeriod): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this.BSPeriod = v;
            this._dataBS = this._dataBS || anychart.data.table();

           
            this.requestPeriod(this._dataBS, this.BSPeriod, this.defaultNumberofPoints,true).then(r => {                
                if(typeof(r)=="string"){
                    this._requestBSId = r;
                } else {
                    this._requestBSId = r.ReqID ||'';
                    this.updateData(r);
                }
            }).catch(e => { console.error(e); });
        });
    }






    private requestPeriod(data: anychart.data.Table, period: HistoryItemPeriod, limit: number,mark:boolean=false): Promise<string | IServiceResponse> {
        return new Promise<string | IServiceResponse>((rs, rj) => {
            data.remove();
            this.dataService.tryToGetFromCache(this.Symbol, period, limit).then(r=>{
                var Periods: IHistoryItem[] = [];
                Periods = Periods.concat(r.Periods || []);
                r.ReqID=`${(new Date()).getTime()}.${Math.random()}.'_'.${this.Symbol}.'_'.${period}.'_'.${limit}`;// dumy local id
                rs(r);
            }).catch(()=>{
                if(this.dataService.canSendRequest){
                this.dataService.sendHistoryRequest(this.Symbol, period, limit)
                .then(r => {
                    rs(r);
                })
                .catch(e => {                     
                    console.error(e); 
                    rj(e);
                });
                } else {
                    this.sendRequestWhenCan(this.Symbol, period, limit);
                }
        });
        });
    }

    private sendRequestWhenCan(symbol: string,period:HistoryItemPeriod,limit:number): Promise<string | IServiceResponse>{
        return new Promise<string | IServiceResponse>((rs, rj) => {
            if(this.dataService.canSendRequest){
                this.dataService.sendHistoryRequest(this.Symbol, period, limit)
                .then(r => {
                    rs(r);
                })
                .catch(e => {                     
                    console.error(e); 
                    rj(e);
                });
            } else {
                setTimeout(()=>{
                    this.sendRequestWhenCan(symbol,period,limit)
                        .then(r=>rs(r))
                        .catch(e=>rj(e));
                },10);
            }
        });
    }

    private async updateData(response: IServiceResponse) {
        var Periods: IHistoryItem[] = [];
        Periods = Periods.concat(response.Periods || []);
        var P = (response.P || []).filter(pu => pu.Symbol == this.Symbol);
        var PLong = P.filter(pu => pu.PeriodType == this.longPeriod);
        var PMidle = P.filter(pu => pu.PeriodType == this.midPeriod);
        var PShort = P.filter(pu => pu.PeriodType == this.shortPeriod);
        var PEntry = P.filter(pu => pu.PeriodType == this.entryPeriod);

        var T = (response.T || []).filter(t => t.S == this.Symbol);

        if (Periods.length > 0) {
            //let pip: number = 0.0001;//this._pip;
            let data: number[][] = Periods.map(element => {
                // candlestick point data
                // [0] - data/time
                // [1] - open
                // [2] - high
                // [3] - low
                // [4] - close
                // [5] - volume
                // [6] - spot
                return [element.t * PERIOD_TIMESTAMP_MULTIPLIER, element.o, element.h, element.l, element.c, element.v, 0];
            });

            if (response.ReqID == this._requestMAId) {
                this._dataMA = this._dataMA || anychart.data.table();
                this._dataMA.addData(data);
                this._lastPiontMA = data[data.length - 1];
                this._prevHistoryPiontMA = data[data.length - 1];

                this.getValueMA(this._dataMA).then(r => {
                    this.ma = r.Count;
                    this.maColor = r.Color;
                }).catch(e => { console.error(e); });
            } else if (response.ReqID == this._requestM1Id) {
                this._dataM1 = this._dataM1 || anychart.data.table();
                this._dataM1.addData(data);
                this._lastPiontM1 = data[data.length - 1];
                this._prevHistoryPiontM1 = data[data.length - 2];
                this._prevHistoryPiontM1_temp = data[data.length - 3];

                // if(this.workspace.mobileMode=="desktop")
                // {
                //      this.buyAndSell = this.computeBuyAndSell()
                // }
               

                this.getValueM(this._dataM1).then(r => {
                    this.m1 = r;
                });

                //   this.buyAndSell=0;
            } else if (response.ReqID == this._requestM2Id) {
                this._dataM2 = this._dataM2 || anychart.data.table();
                this._dataM2.addData(data);
                this._lastPiontM2 = data[data.length - 1];
                this._prevHistoryPiontM2 = data[data.length - 1];

                this.getValueM(this._dataM2).then(r => {
                    this.m2 = r;
                }).catch(e => { console.error(e); });
            } else if (response.ReqID == this._requestM3Id) {
                this._dataM3 = this._dataM3 || anychart.data.table();
                this._dataM3.addData(data);
                this._lastPiontM3 = data[data.length - 1];
                this._prevHistoryPiontM3 = data[data.length - 1];

                this.getValueM(this._dataM3).then(r => {
                    this.m3 = r;
                }).catch(e => { console.error(e); });
            } else if (response.ReqID == this._requestLId) {
                this._dataL = this._dataL || anychart.data.table();
                this._dataL.addData(data);
                this._lastPiontL = data[data.length - 1];

                this.long = <any>computeValueES(this._dataL, this._lastPiontL[0])[0];
            } else if (response.ReqID == this._requestMId) {
                this._dataM = this._dataM || anychart.data.table();
                this._lastPiontM = data[data.length - 1];
                this._dataM.addData(data);

                this.middle = <any>computeValueES(this._dataM, this._lastPiontM[0])[0];
            } else if (response.ReqID == this._requestSId) {
                this._dataS = this._dataS || anychart.data.table();
                this._lastPiontS = data[data.length - 1];
                this._dataS.addData(data);

                this.short = <any>computeValueES(this._dataS, this._lastPiontS[0])[0];
            } else if (response.ReqID == this._requestEId) {
                this._dataE = this._dataE || anychart.data.table();
                this._lastPiontE = data[data.length - 1];
                this._dataE.addData(data);

                this.entry = <any>computeValueES(this._dataE, this._lastPiontE[0])[0];
            }
            else if (response.ReqID == this._requestVLId) {
             
                this._dataVL = this._dataVL || anychart.data.table();
                this._lastPiontVL = data[data.length - 1];
                this._dataVL.addData(data);
             
             //   this.entry = computeValueES(this._dataE, this._lastPiontE[0]);
            }
            else if (response.ReqID == this._requestBSId) {
                
            
             if(this.enableBuyAndSell)
                {

                    data = data.reverse();
                this._dataBS = this._dataBS || anychart.data.table();
                this._lastPiontBS = data[data.length - 1];

                let periodValue = getHistoryItemPeriodValue(Number(response.Period));
                let tmp =  data[data.length - 1] [0] +   periodValue;

                let dataEnd = data[data.length - 1] [0] + 20 * periodValue;

               
                    // while (tmp < dataEnd) {
                    //     data.push([
                    //         tmp,
                    //          data[data.length - 1][1],
                    //          data[data.length - 1][2],
                    //          data[data.length - 1][3],
                    //          data[data.length - 1][4],
                    //          data[data.length - 1][5],
                    //          data[data.length - 1][6]
                    //     ]);
                    //     tmp += periodValue;
                    // }
                
              
                this._dataBS.addData(data);

                this._lastPiontBS = data[data.length - 1];
                this._prevHistoryPiontBS = data[data.length - 2];
                this._prevHistoryPiontBS_temp = data[data.length - 3];
              
                    if(Number(response.Period) == Number(this.BSPeriod))
                    {
                         this.buyAndSell =  this.computeBuyAndSell(this._dataBS,this.chartRange,this.BSPeriod)
                    }
                    
                }
               
    
            }

            if (this.quoteTabObj != null) {
                this.quoteTabObj.update();
            }
        }

        if (this._dataL && PLong.length > 0) {
            this._lastPiontL = [
                PLong[0].Period.t * PERIOD_TIMESTAMP_MULTIPLIER,
                PLong[0].Period.o,
                PLong[0].Period.h,
                PLong[0].Period.l,
                PLong[0].Period.c
            ];
            this._dataL.addData([this._lastPiontL]);
            this.long = <any>computeValueES(this._dataL, this._lastPiontL[0])[0];
        }

        if (this._dataM && PMidle.length > 0) {
            this._lastPiontM = [
                PMidle[0].Period.t * PERIOD_TIMESTAMP_MULTIPLIER,
                PMidle[0].Period.o,
                PMidle[0].Period.h,
                PMidle[0].Period.l,
                PMidle[0].Period.c
            ];
            this._dataM.addData([this._lastPiontM]);
            this.middle = <any>computeValueES(this._dataM, this._lastPiontM[0])[0];
        }

        if (this._dataS && PShort.length > 0) {
            this._lastPiontS = [
                PShort[0].Period.t * PERIOD_TIMESTAMP_MULTIPLIER,
                PShort[0].Period.o,
                PShort[0].Period.h,
                PShort[0].Period.l,
                PShort[0].Period.c
            ];
            this._dataS.addData([this._lastPiontS]);
            this.short = <any>computeValueES(this._dataS, this._lastPiontS[0])[0];
        }

        if (this._dataE && PEntry.length > 0) {
            this._lastPiontE = [
                PEntry[0].Period.t * PERIOD_TIMESTAMP_MULTIPLIER,
                PEntry[0].Period.o,
                PEntry[0].Period.h,
                PEntry[0].Period.l,
                PEntry[0].Period.c
            ];
            this._dataE.addData([this._lastPiontE]);
            this.entry = <any>computeValueES(this._dataE, this._lastPiontE[0])[0];
        }
    }

    private _enableBuyAndSell: boolean = false;
    public get enableBuyAndSell (): boolean {
        return this._enableBuyAndSell;
    }
    public set enableBuyAndSell ( value: boolean ) {
        this._enableBuyAndSell = value;
    }


    private lastBid: number = 0;
    private async updateFromTicks(response: IServiceResponse) {
        if (response.T) {
            var q = response.T.filter(x => x.S == this.Symbol);
            if (q.length > 0) {

               
               

                if (this._lastPiontMA.length > 0 && this._dataMA) {
                    this._lastPiontMA[2] = this._lastPiontMA[2] < q[0].B ? q[0].B : this._lastPiontMA[2];
                    this._lastPiontMA[3] = this._lastPiontMA[3] > q[0].B ? q[0].B : this._lastPiontMA[3];
                    this._lastPiontMA[4] = q[0].B;
                    this._dataMA.addData([
                        [
                            this._lastPiontMA[0],
                            this._lastPiontMA[1],
                            this._lastPiontMA[2],
                            this._lastPiontMA[3],
                            this._lastPiontMA[4]
                        ]
                    ]);
                    if (this._timeoutMA) clearInterval(this._timeoutMA);
                    this._timeoutMA = setTimeout(() => {
                        if (this._dataMA)
                            this.getValueMA(this._dataMA).then(r => {
                                this.ma = r.Count;
                                this.maColor = r.Color;
                            }).catch(e => { console.error(e); });
                    }, 100);
                }

                if (this._lastPiontM1.length > 0 && this._dataM1) {
                    this._lastPiontM1[2] = this._lastPiontM1[2] < q[0].B ? q[0].B : this._lastPiontM1[2];
                    this._lastPiontM1[3] = this._lastPiontM1[3] > q[0].B ? q[0].B : this._lastPiontM1[3];
                    this._lastPiontM1[4] = q[0].B;

                    this._dataM1.addData([
                        [
                            this._lastPiontM1[0],
                            this._lastPiontM1[1],
                            this._lastPiontM1[2],
                            this._lastPiontM1[3],
                            this._lastPiontM1[4]
                        ]
                    ]);
                    if (this._timeoutM1) clearInterval(this._timeoutM1);
                    this._timeoutM1 = setTimeout(() => {
                        if (this._dataM1)
                            this.getValueM(this._dataM1).then(r => {
                                this.m1 = r;
                            }).catch(e => { console.error(e); });
                    }, 100);
                }

                if (this._lastPiontM2.length > 0 && this._dataM2) {
                    this._lastPiontM2[2] = this._lastPiontM2[2] < q[0].B ? q[0].B : this._lastPiontM2[2];
                    this._lastPiontM2[3] = this._lastPiontM2[3] > q[0].B ? q[0].B : this._lastPiontM2[3];
                    this._lastPiontM2[4] = q[0].B;
                    this._dataM2.addData([
                        [
                            this._lastPiontM2[0],
                            this._lastPiontM2[1],
                            this._lastPiontM2[2],
                            this._lastPiontM2[3],
                            this._lastPiontM2[4]
                        ]
                    ]);
                    if (this._timeoutM2) clearInterval(this._timeoutM2);
                    this._timeoutM2 = setTimeout(() => {
                        if (this._dataM2)
                            this.getValueM(this._dataM2).then(r => {
                                this.m2 = r;
                            }).catch(e => { console.error(e); });
                    }, 100);
                }

                if (this._lastPiontM3.length > 0 && this._dataM3) {
                    this._lastPiontM3[2] = this._lastPiontM3[2] < q[0].B ? q[0].B : this._lastPiontM3[2];
                    this._lastPiontM3[3] = this._lastPiontM3[3] > q[0].B ? q[0].B : this._lastPiontM3[3];
                    this._lastPiontM3[4] = q[0].B;
                    this._dataM3.addData([
                        [
                            this._lastPiontM3[0],
                            this._lastPiontM3[1],
                            this._lastPiontM3[2],
                            this._lastPiontM3[3],
                            this._lastPiontM3[4]
                        ]
                    ]);
                    if (this._timeoutM3) clearInterval(this._timeoutM3);
                    this._timeoutM3 = setTimeout(() => {
                        if (this._dataM3)
                            this.getValueM(this._dataM3).then(r => {
                                this.m3 = r;
                            }).catch(e => { console.error(e); });
                    }, 100);
                }


                if(this.enableBuyAndSell)
                {

                if (this._lastPiontBS.length > 0 && this._dataBS) {
                    this._lastPiontBS[2] = this._lastPiontBS[2] < q[0].B ? q[0].B : this._lastPiontBS[2];
                    this._lastPiontBS[3] = this._lastPiontBS[3] > q[0].B ? q[0].B : this._lastPiontBS[3];
                    this._lastPiontBS[4] = q[0].B;
                    this._dataBS.addData([
                        [
                            this._lastPiontBS[0],
                            this._lastPiontBS[1],
                            this._lastPiontBS[2],
                            this._lastPiontBS[3],
                            this._lastPiontBS[4]
                        ]
                    ]);

                    if (this._timeoutBS) clearTimeout(this._timeoutBS);
                    this._timeoutBS = setTimeout(() => {
                        if (this._dataBS)
                        {
                         //   console.log("TICKBS")
                         //   this.buyAndSell =  this.computeBuyAndSell(this._dataBS,this.chartRange,this.BSPeriod)
                        }
                            // this.getValueM(this._dataM2).then(r => {
                            //     this.m2 = r;
                            // }).catch(e => { console.error(e); });
                    }, 100);

                }

            }











                // if(this._dataBS)
                // this.buyAndSell = this.computeBuyAndSell(this._dataBS);
            }
        }
    }

    private _wizardRequest: boolean = false;
    public get wizardRequest(): boolean {
        return this._wizardRequest;
    }
    public set wizardRequest(value: boolean) {
        this._wizardRequest = value;
    }

    public getValueM(
        data: anychart.data.Table,
        endDate?: number,
        period?: HistoryItemPeriod,
        inputStartDate: number = -2
    ): Promise<number> {
        let promise = new Promise<number>((rs, rj) => {
            var d: number = 0; // last value from close
            var highValue: number = -1000000;
            var lowValue: number = 1000000;
            var res: number = 0;

            var mapping = data.mapAs();
            mapping.addField("close", 4);
            var startDate = inputStartDate;

            if (inputStartDate == -2) {
                startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
            } else {
                startDate = inputStartDate;
            }
            var sel =
                startDate > 0 && endDate
                    ? mapping.createSelectable().select(startDate, endDate)
                    : mapping.createSelectable().selectAll();
            var iter = sel.getIterator();

            var deviotion: number[] = [];
            var prevValue = -999999;

            while (iter.advance()) {
                var c = iter.get("close");

                if (prevValue == -999999) {
                    deviotion.push(0);
                } else {
                    if (c != prevValue) {
                        deviotion.push(100 * (prevValue != 0 ? (c - prevValue) / prevValue : 0));
                    }
                }

                prevValue = c;
            }

            d = deviotion.length > 0 ? deviotion[deviotion.length - 1] : 0;
            highValue = Math.max.apply(null, deviotion);
            lowValue = Math.min.apply(null, deviotion);
            var highDeviation: number = Math.abs(highValue);
            var lowDeviation: number = Math.abs(lowValue);
            d = d * 1.5; // all are currencies
            highDeviation = highDeviation > 5 ? 5 : highDeviation;
            lowDeviation = lowDeviation > 5 ? 5 : lowDeviation;
            d = d > 0 ? d / highDeviation : d / lowDeviation;

            d = d < -1 ? -1 : d;
            d = d > 1 ? 1 : d;
            d = d * 100;
            d = Math.ceil(d);

            if (this.wizardRequest) {
                if (prevValue == -999999) {
                    d = -999999;
                }
            }
            rs(d);
        });
        return promise;
    }

    public getValueM1(endDate?: number, period?: HistoryItemPeriod, inputStartDate: number = -2): Promise<number> {
        if (this._dataM1) {
            return this.getValueM(this._dataM1, endDate, period, inputStartDate);
        } else {
            return new Promise<number>((rs, rj) => {
                rs(0);
            });
        }
    }
    public getValueM2(endDate?: number, period?: HistoryItemPeriod, inputStartDate: number = -2): Promise<number> {
        if (this._dataM2) {
            return this.getValueM(this._dataM2, endDate, period, inputStartDate);
        } else {
            return new Promise<number>((rs, rj) => {
                rs(0);
            });
        }
    }

    public getValueM3(endDate?: number, period?: HistoryItemPeriod, inputStartDate: number = -2): Promise<number> {
        if (this._dataM3) {
            return this.getValueM(this._dataM3, endDate, period, inputStartDate);
        } else {
            return new Promise<number>((rs, rj) => {
                rs(0);
            });
        }
    }

    public getValueMA(
        data: anychart.data.Table,
        endDate?: number,
        period?: HistoryItemPeriod,
        inputStartDate: number = -2
    ): Promise<IMIndicatorResult> {
        let promise = new Promise<IMIndicatorResult>((rs, rj) => {
            let result: IMIndicatorResult = {
                Count: 0,
                Color: "yellow"
            };

            var redCtx: anychart.math.sma.Context = anychart.math.sma.initContext(89);
            var yellowCtx: anychart.math.sma.Context = anychart.math.sma.initContext(89);
            var mapping = data.mapAs();
            //    mapping.addField("dt", 0);// key - DateTime
            //    mapping.addField("open", 1);
            mapping.addField("high", 2);
            mapping.addField("low", 3);
            mapping.addField("close", 4);
            var startDate = inputStartDate;

            if (inputStartDate == -2) {
                startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
            } else {
                startDate = inputStartDate;
            }
            
            var sel =
                startDate > 0 && endDate
                    ? mapping.createSelectable().select(startDate, endDate)
                    : mapping.createSelectable().selectAll();
            var iter = sel.getIterator();

            while (iter.advance()) {
                var high = iter.get("high");
                var low = iter.get("low");
                var c = iter.get("close");

                var red = anychart.math.sma.calculate(redCtx, low);
                var yellow = anychart.math.sma.calculate(yellowCtx, high);

                if (!isNaN(red) && !isNaN(yellow)) {
                    if (c < red) {
                        result.Count = result.Color != "red" ? 0 : result.Count;
                        result.Color = "red";
                        result.Count++;
                    } else if (yellow > c && c > red) {
                        result.Count = result.Color != "yellow" ? 0 : result.Count;
                        result.Color = "yellow";
                        result.Count++;
                    } else {
                        result.Count = result.Color != "green" ? 0 : result.Count;
                        result.Color = "green";
                        result.Count++;
                    }
                   
                }
            }
            
            rs(result);
        });
        return promise;
    }

    public getVolatility(
        data: anychart.data.Table,
        endDate?: number,
        period?: HistoryItemPeriod,
        inputStartDate:number = -2
    ): Promise<number> {
        let promise = new Promise<number>((rs, rj) => {
     
            let d = computeVolatility(data, endDate, period, inputStartDate);
            rs(d);
        });
        return promise;
    }

public updateBS()
{
    if(this._dataBS)
    {
        this.buyAndSell =  this.computeBuyAndSell(this._dataBS,this.chartRange,this.BSPeriod)
    }
    console.log(this.buyAndSell);
}

public computeBuyAndSell(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod, startDate: number = -2)
{

    let smachWizardPeriod = 89;


    var lowCtx: anychart.math.sma.Context = anychart.math.sma.initContext(smachWizardPeriod);
    var highCtx: anychart.math.sma.Context = anychart.math.sma.initContext(smachWizardPeriod);
  
    var mapping = data.mapAs();
    mapping.addField("dt", 0);
    mapping.addField("high", 2);
    mapping.addField("low", 3);
    mapping.addField("close", 4);
    
   
     var sel = mapping.createSelectable().selectAll()
     var iterlong = sel.getIterator();


    if(startDate==-2)
    {
        startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 200 : -1;
    }
    
// console.log([startDate, endDate])
//     var sel =
//         startDate > 0 && endDate
//             ? mapping.createSelectable().select(startDate, endDate)
//             : mapping.createSelectable().selectAll();
//     var iterVolumeMa = sel.getIterator();


   // var iterlong = sel.getIterator();










    let longValues:any = [];
    while (iterlong.advance()) {
        var dt = iterlong.get("dt");
        var h = iterlong.get("high");
        var l = iterlong.get("low");
        var c = iterlong.get("close");
        

        var hv = anychart.math.sma.calculate(highCtx, h);
        var lv = anychart.math.sma.calculate(lowCtx, l);

        longValues.push({
            date: dt,
            hvalue: hv,
            lvalue: lv,
            dataVal: c,
            high:h,
            low:l,
        });
    }



  //  console.log(longValues);
   
    if(longValues.length>0)
    {

   
        let lastVal = longValues[longValues.length-1];
        let diff =  (lastVal.hvalue - lastVal.lvalue);
        let range = Math.abs(diff*5);

        let computeCenter = lastVal.lvalue + diff/2

        let factor = 0;
        let perc = 0;

        if(computeCenter>lastVal.dataVal)
        {
            factor = -1;

        //  let relLength = Math.abs(computeCenter - range)
            let relVal = Math.abs(computeCenter - lastVal.dataVal)
            perc = 100*(relVal/range);

        // perc = 100 * (Math.abs(lastVal.dataVal - (computeCenter - range))/range)
        }
        else
        {

        //   let relLength = Math.abs(computeCenter - range)
            let relVal = Math.abs(lastVal.dataVal - computeCenter)
            perc = 100*(relVal/range);

            factor = 1;
        //   perc = 100 * (Math.abs((computeCenter + range) - lastVal.dataVal)/range);
        }

        return factor*perc;

        //console.log([factor,perc,lastVal])
    }
    return 0;
}







    public _computeBuyAndSell()
    {
            let bid = 1;
            let prevBid = this._prevHistoryPiontBS[4];

            if(this.box.Bid!=-1)
            {
                bid = this.box.Bid;
            }
            else
            {
            bid =  this._prevHistoryPiontBS[4];
            prevBid = this._prevHistoryPiontBS_temp[4];
            }

        

            let bAs = isNaN(this._prevHistoryPiontBS[4])
                    ? 0
                    : // : Math.ceil(Number((this._prevHistoryPiontM1[4] - this.box.Bid) / Math.pow(10, -(this.box.Decimal-1))));
                //    Math.ceil(
                        Number((prevBid - bid) / bid) /
                            Math.pow(10, -(this.box.Decimal - 1))


                //    );
            if(bAs<-5000)
            {
            //   debugger
            }
            return bAs;

    }

    
}

namespace math.wizard {
    export interface IWizardIndicatorContext {
        wzResult: number;
        redResult: number;
        yellowResult: number;
        redValueField: string;
        yellowValueField: string;
        mainVauleField: string;
        period?: number;
        redCtx: anychart.math.sma.Context;
        yellowCtx: anychart.math.sma.Context;
        redPrevCtx: anychart.math.sma.Context;
        yellowPrevCtx: anychart.math.sma.Context;
    }

    export function initContext(
        redField: string,
        yellowField: string,
        mainField: string,
        period?: number
    ): IWizardIndicatorContext {
        var ctx: IWizardIndicatorContext = {
            wzResult: 0,
            redResult: NaN,
            yellowResult: NaN,
            redValueField: redField,
            yellowValueField: yellowField,
            mainVauleField: mainField,
            period: period,
            redCtx: anychart.math.sma.initContext(period),
            yellowCtx: anychart.math.sma.initContext(period),
            redPrevCtx: anychart.math.sma.initContext(period),
            yellowPrevCtx: anychart.math.sma.initContext(period)
        };
        return ctx;
    }

    export function startFunction(context: IWizardIndicatorContext) {
        anychart.math.sma.startFunction(context.redCtx);
        anychart.math.sma.startFunction(context.yellowCtx);
        context.redResult = NaN;
        context.yellowResult = NaN;
    }

    export function calculationFunction(row: anychart.data.TableComputer.RowProxy, context: IWizardIndicatorContext) {
        var redV = Number(row.get(context.redValueField));
        var yellowV = Number(row.get(context.yellowValueField));
        var mainV = Number(row.get(context.mainVauleField));
        var rv = calculate(context, redV, yellowV, mainV);

        var mResult = rv[0];
        var rResult = rv[1];
        var yResult = rv[2];

        row.set("mResult", mResult);
        row.set("rResult", rResult);
        row.set("yResult", yResult);
    }

    export function calculate(context: IWizardIndicatorContext, fv: number, sv: number, mv: number): number[] {
        if (!isNaN(fv) && !isNaN(sv) && !isNaN(mv)) {
            var fr = anychart.math.sma.calculate(context.redCtx, fv);
            var sr = anychart.math.sma.calculate(context.yellowCtx, sv);
            var mr = 0;

            if (fr < mv) {
                mr = (context.wzResult > 0 ? 0 : context.wzResult) - 1;
            } else if (sr > mv) {
                mr = (context.wzResult < 0 ? 0 : context.wzResult) + 1;
            }
            return [mr, fr, sr];
        } else {
            return [NaN, NaN, NaN]; // 0,0,0
        }
    }
}

namespace math.es {
    export interface IEntrySignalsIndicatorContext {
        Result: number; // -1/0/1
        BResult: number;
        WResult: number;
        bValueField: string;
        wValueField: string;
        bPeriod?: number;
        wPeriod?: number;
        bCtx: anychart.math.ema.Context;
        wCtx: anychart.math.ema.Context;
        bPrevCtx: anychart.math.ema.Context;
        wPrevCtx: anychart.math.ema.Context;
    }

    export function initContext(
        bField: string,
        wField: string,
        bPeriod?: number,
        wPeriod?: number
    ): IEntrySignalsIndicatorContext {
        var bP = bPeriod || 8;
        var wP = wPeriod || 2;
        bP = !isNaN(Number(bP)) ? 8 : Number(bP);
        wP = !isNaN(Number(wP)) ? 2 : Number(wP);
        var ctx: IEntrySignalsIndicatorContext = {
            Result: NaN,
            BResult: NaN,
            WResult: NaN,
            bValueField: bField,
            wValueField: wField,
            bPeriod: bP,
            wPeriod: wP,
            bCtx: anychart.math.ema.initContext(bP),
            wCtx: anychart.math.ema.initContext(wP),
            bPrevCtx: anychart.math.ema.initContext(bP),
            wPrevCtx: anychart.math.ema.initContext(wP)
        };
        return ctx;
    }

    export function startFunction(context: IEntrySignalsIndicatorContext) {
        anychart.math.ema.startFunction(context.bCtx);
        anychart.math.ema.startFunction(context.wCtx);
        context.Result = NaN;
        context.BResult = NaN;
        context.WResult = NaN;
    }

    export function calculationFunction(
        row: anychart.data.TableComputer.RowProxy,
        context: IEntrySignalsIndicatorContext
    ) {
        var bV = Number(row.get(context.bValueField));
        var wV = Number(row.get(context.wValueField));
        var rv = calculate(context, bV, wV);

        var mResult = rv[0];
        var bResult = rv[1];
        var wResult = rv[2];

        row.set("mResult", mResult);
        row.set("bResult", bResult);
        row.set("wResult", wResult);
    }

    export function calculate(context: IEntrySignalsIndicatorContext, bv: number, wv: number): number[] {
        if (!isNaN(bv) && !isNaN(wv)) {
            var br = anychart.math.ema.calculate(context.bCtx, bv);
            var wr = anychart.math.ema.calculate(context.wCtx, wv);
            return [br > wr ? -1 : br < wr ? 1 : 0, br, wr];
        } else {
            return [NaN, NaN, NaN]; // 0,0,0
        }
    }
}

export function getRndInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
}

export const emaBlackPeriod = 30;
export const emaWhitePeriod = 15;

export interface IEmaResult {
    date: number;
    value: number;
}

export function computeValueES(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod,mark?:any) {
    var blackCtx: anychart.math.ema.Context = anychart.math.ema.initContext(emaBlackPeriod);
    var whiteCtx: anychart.math.ema.Context = anychart.math.ema.initContext(emaWhitePeriod);

    var mapping = data.mapAs();
    mapping.addField("dt", 0); // key - DateTime
    // mapping.addField("open", 1);
    // mapping.addField("high", 2);
    // mapping.addField("low", 3);
    mapping.addField("close", 4);
    var startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
    // var sel =
    //     startDate > 0 && endDate
    //         ? mapping.createSelectable().select(startDate, endDate)
    //         : mapping.createSelectable().selectAll();


   var sel = mapping.createSelectable().selectAll();


    var iterBlack = sel.getIterator();
    var iterWhite = sel.getIterator();

    var res = 0;

    // endDate=endDate|| Date.now();

    var blackValues: IEmaResult[] = [];
    var whiteValues: IEmaResult[] = [];

    while (iterBlack.advance()) {
        var dt = iterBlack.get("dt");
        var c = iterBlack.get("close");
        var black = anychart.math.ema.calculate(blackCtx, c);
        blackValues.push({
            date: dt,
            value: black
        });
    }

    while (iterWhite.advance()) {
        var dt = iterWhite.get("dt");
        var c = iterWhite.get("close");
        var white = anychart.math.ema.calculate(whiteCtx, c);
        whiteValues.push({
            date: dt,
            value: white
        });
    }
   
    if (blackValues.length > 0 && whiteValues.length > 0) {
        res =
            blackValues[blackValues.length - 1].value > whiteValues[whiteValues.length - 1].value
                ? -1
                : blackValues[blackValues.length - 1].value < whiteValues[whiteValues.length - 1].value
                ? 1
                : 0;
    } else res = 0;

    //res = black > white ? -1 : black < white ? 1 : 0;
    if(blackValues[blackValues.length - 1]!=undefined)
    {
         return [res,blackValues[blackValues.length - 1].value,whiteValues[whiteValues.length - 1].value, data];
    }
    else
    {
        return [res]
    }
}

export const atrPeriod = 14;
export function computeVolatility(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod, startDate: number = -2) {
    var atrCtx: anychart.math.atr.Context = anychart.math.atr.initContext(atrPeriod);

    var mapping = data.mapAs();

    mapping.addField("dt", 0); // key - DateTime
    mapping.addField("open", 1);
    mapping.addField("high", 2);
    mapping.addField("low", 3);
    mapping.addField("close", 4);
    mapping.addField("volume", 5);

    if(startDate==-2)
    {
        startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
    }
    

    var sel =
        startDate > 0 && endDate
            ? mapping.createSelectable().select(startDate, endDate)
            : mapping.createSelectable().selectAll();
    var iterVolumeMa = sel.getIterator();

    let Atr: number[] = [];
    let i= 0;
    while (iterVolumeMa.advance()) {
       
        //  var dt = iterBlack.get("dt");
        var c = iterVolumeMa.get("close");
        var h = iterVolumeMa.get("high");
        var l = iterVolumeMa.get("low");

        if(i==0)
        {
     
            i++;
        }


        var black = anychart.math.atr.calculate(atrCtx, c, h, l);
        if (!isNaN(black)) {
            Atr.push(black);
        }
    }

   



    let max = Math.max(...Atr);
    let last = Atr[Atr.length - 1];

    let scaleVal = (150 * last) / max;

    return scaleVal;
}
